import { makeStyles } from "@material-ui/styles";
import gameMuiTheme from "../../layout/styles/GameMuiTheme";

const headerHeight = 120;
const headerHeightWithAlert = 60;

const commonStyles = makeStyles((theme) => ({
	container: {
		height: "100%",
		overflow: "auto"
	},
	headerContainer: {
		display: "flex",
		padding: ({ withAlert }) => (withAlert ? 0 : theme.spacing(4, 4, 4, 4)),
		[theme.breakpoints.only("xs")]: {
			padding: theme.spacing(1, 1, 1, 2)
		},
		height: ({ withAlert }) => (withAlert ? headerHeightWithAlert : headerHeight),
		overflow: "auto",
		justifyContent: ({ withAlert }) => (withAlert ? "center" : ""),
		alignItems: ({ withAlert }) => (withAlert ? "center" : "")
	},
	textContainer: {
		flexGrow: "1",
		alignSelf: "flex-end"
	},
	primaryActionsContainer: {
		display: "flex",
		alignItems: "center"
	},
	contentContainer: {
		height: ({ withAlert, withHeader = true }) => {
			let shiftedHeight = 0;
			if (withAlert) {
				shiftedHeight = headerHeightWithAlert;
			} else if (withHeader) {
				shiftedHeight = headerHeight;
			}

			return `calc(100% - ${shiftedHeight}px)`;
		}
	},
	loadingContainer: {
		padding: theme.spacing(0, 4)
	},
	infoContainer: {
		height: "calc(100% - 86px)",
		[theme.breakpoints.only("sm")]: {
			height: "calc(100% - 136px)"
		},
		[theme.breakpoints.only("xs")]: {
			height: "calc(100% - 116px)"
		}
	},
	boxContainer: {
		position: "relative",
		height: "100%"
	},
	form: {
		height: "100%",
		"& > div:first-of-type": {
			height: "calc(100% - 65px)",
			overflow: "auto",
			width: "100%"
		},
		position: "relative",
		overflow: "hidden"
	},
	centerContainer: {
		height: "calc(100% - 65px)",
		padding: theme.spacing(0, 4)
	},
	actionToolbar: {
		borderTop: `1px solid ${theme.palette.secondary.main}`,
		bottom: 0,
		right: 0,
		width: "100%"
	},
	flexWrap: {
		flexWrap: "wrap"
	},
	headerAlert: {
		maxHeight: 20,
		flexBasis: "100%"
	},
	content: {
		marginTop: 100
	},
	contentCentered: {
		alignItems: "center",
		height: "100%"
	},
	scrollableContent: {
		overflowX: "hidden",
		overflowY: "auto",
		"&::-webkit-scrollbar": {
			width: 4
		},
		"&::-webkit-scrollbar-track": {
			backgroundColor: gameMuiTheme.palette.gameMode.secondary
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "white",
			borderColor: "transparent"
		}
	},
	contentCenteredIcon: {
		fontSize: 72
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1)
	},
	matchNumber: {
		marginLeft: 10,
		width: "10%"
	},
	divider: {
		width: "100%",
		margin: theme.spacing(7, 0)
	},
	error: {
		backgroundColor: "#ffebcd"
	}
}));

export default commonStyles;
